module.exports = __webpack_public_path__ + "img/level_three_lock.204dae55.png";